import { configureStore } from "@reduxjs/toolkit";
import paymentSlice from "./reducers/payment";

export const store = configureStore({
  reducer: {
    payment: paymentSlice,
  },
});
